import RecordAudioComponent from './record-audio.component'

export default RecordAudioComponent
